module.exports = __webpack_public_path__ + "static/media/example-00.2015bba9.jpg";